import React, { Fragment } from 'react';
import classnames from 'classnames';
import TEXT from '../../../../../data/text.json';

export default () => (
  <p>
    {TEXT.FORMS.emailNotice.split('[privacy policy]')[0]}
    <a
      href="/privacy-policy"
      target="_blank"
      style={{ textDecoration: 'underline' }}
    >
      privacy policy
    </a>
    {TEXT.FORMS.emailNotice.split('[privacy policy]')[1]}
  </p>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/form-components/email-notice/index.js